import rawMetadata from "./pageMetadata.json";

type PageMetadata = typeof rawMetadata.pages;
type PageKey = keyof PageMetadata;
export type LearningPageKey = Exclude<PageKey, "home" | "privacy" | "terms">;

export const siteMetadata = rawMetadata.site;
export const personMetadata = rawMetadata.person;
export const pageMetadata = rawMetadata.pages;

export const learningPageKeys = Object.keys(pageMetadata).filter(
  (key): key is LearningPageKey =>
    key !== "home" && key !== "privacy" && key !== "terms"
);

export const isLearningPageKey = (value: string): value is LearningPageKey =>
  learningPageKeys.includes(value as LearningPageKey);

export const getAbsoluteUrl = (path: string) =>
  path.startsWith("http") ? path : `${siteMetadata.url}${path}`;

export const getAbsoluteAssetUrl = (path: string) => getAbsoluteUrl(path);

export const homePageMetadata = pageMetadata.home;
